import { useQuery } from '@tanstack/react-query';
import { fetchJSON } from './api-client';

interface SymbolNameResponse {
  symbol: string;
  name: string | null;
}

/**
 * 取得公司名（台股中文、美股英文）。走後端 offline map，便宜且 cache 一天。
 * react-query 以 symbol 去重，多張卡片同一檔只打一次。
 */
export function useSymbolName(symbol: string): string | undefined {
  const q = useQuery({
    queryKey: ['symbol-name', symbol],
    queryFn: () => fetchJSON<SymbolNameResponse>(`/api/symbol-name/${encodeURIComponent(symbol)}`),
    enabled: !!symbol,
    staleTime: 24 * 60 * 60_000,
    gcTime: 24 * 60 * 60_000,
    retry: 1,
  });
  return q.data?.name ?? undefined;
}
